module.exports = __webpack_public_path__ + "static/media/FFEP_230224.76d0dc7a.jpg";